// extracted by mini-css-extract-plugin
export default {"msg_chairman_main":"MessageFromChairman_msg_chairman_main__HndT+","msg_chairman_text":"MessageFromChairman_msg_chairman_text__L3C+o"};